import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import {
    getHealthCalendarApi,
    getHealthDictTreeApi,
    getHealthByDateApi,
    getHealthByIdApi,
    postHealthCommentApi,
    putHealthCommentApi,
    postEventsDataApi,
    getEventsDataApi,


} from 'api'
import { BoundarySlice } from 'redux/reducers'

const initialState = {
    calendarInfo: null, // 被点击的日历信息
    calendarData: null, // 日历上当前范围内显示的总结填写信息
    dictData: null, // 数据字典
    listData: null, // 回显数据
    locationName: '', // location 名称
    locationId: '', // location id
    save: false,
    id: '',
}
/* 获取日历上的数据 */
export const getHealthCalendarAction = createAsyncThunk(
    'HealthSlice/getHealthCalendarAction',
    async (params, thunkAPI) => {
        try {
            const { data } = await getHealthCalendarApi(params)
            return data.data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* 获取数据字典 */
export const getHealthDictDataAction = createAsyncThunk(
    'HealthSlice/getHealthDictDataAction',
    async (dictType, thunkAPI) => {
        const eventDataDict = getHealthDictTreeApi(dictType[0]) // 事件
        const companyDataDict = getHealthDictTreeApi(dictType[1]) // 单位
        return Promise.all([ eventDataDict, companyDataDict])
            .then(dictData => dictData)
            .catch(error => thunkAPI.dispatch(BoundarySlice.actions.addError(error)))
    }
)

/* 通过日期获取 id */
export const getHealthByDateAction = createAsyncThunk(
    'HealthSlice/getHealthByDateAction',
    async (listDataParams, thunkAPI) => {
        try {
            const commentData = await getHealthByDateApi(listDataParams) // 通过日期查询 id
            return commentData?.data?.data?.id
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* 获取数据 */
export const getHealthDataAction = createAsyncThunk('HealthSlice/getHealthDataAction', async (id, thunkAPI) => {
    const commentData = getHealthByIdApi(id) // 通过 id 查询
    const eventData = getEventsDataApi(id)
    return Promise.all([commentData, eventData])
        .then(listData => listData)
        .catch(error => thunkAPI.dispatch(BoundarySlice.actions.addError(error)))
})

/* 保存数据 */
export const postHealthDataAction = createAsyncThunk(
    'HealthSlice/postHealthDataAction',
    async ({ id, commentParams, eventParams,}, { dispatch }) => {
        let vid
        try {
            if (!id) {
                const commentData = await postHealthCommentApi(commentParams) // 新增
                vid = commentData.data.data.id
                await postEventsDataApi(eventParams, commentData.data.data.id)
                dispatch(HealthSlice.actions.addId(vid))
                return { isTrue: true, id: vid } // 已保存状态
            } else {
                vid = id
                await putHealthCommentApi(commentParams, id) // 修改
                await postEventsDataApi(eventParams, id)
               
                return { isTrue: true, id } // 已保存状态
            }
        } catch (error) {
            dispatch(HealthSlice.actions.addId(vid))
            dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

export const HealthSlice = createSlice({
    name: 'HealthSlice',
    initialState,
    reducers: {
        /* 日历点击信息 */
        addCalendarInfo: (state, action) => {
            state.calendarInfo = action.payload
        },
        /* 清空日历与详情页信息 */
        clearListData: state => {
            state.listData = null
            state.calendarData = null
            state.save = false
            state.id = ''
        },
        /* 当前日历主 id */
        addId: (state, action) => {
            state.id = action.payload
        },
        /* location 名称 */
        addLocationName: (state, action) => {
            state.locationName = action.payload
        },
        /* location id */
        addLocationId: (state, action) => {
            state.locationId = action.payload
        },
    },
    extraReducers: {
        /* 获取日历上的数据 */
        [getHealthCalendarAction.fulfilled.type]: (state, action) => {
            state.calendarData = action.payload
        },

        /* 处理数据字典 */
        [getHealthDictDataAction.fulfilled.type]: (state, action) => {        
            state.dictData = action.payload
        },

        /* 提交总结数据 */
        [postHealthDataAction.fulfilled.type]: (state, action) => {
            state.save = action.payload
        },

        /* 获取回显数据 */
        [getHealthDataAction.fulfilled.type]: (state, action) => {
            state.listData = action.payload
        },

        /* 通过日期，获取 id */
        [getHealthByDateAction.fulfilled.type]: (state, action) => {
            state.id = action.payload
        },
    },
})
